import { render, staticRenderFns } from "./VerifiedUser.vue?vue&type=template&id=5ec5027c"
import script from "./VerifiedUser.vue?vue&type=script&lang=js"
export * from "./VerifiedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports